import { DropdownButton, ValueType } from '@appkit4/react-components/dropdown';
import { ItemDataType } from '@appkit4/react-components/filter';
import React, { SyntheticEvent, useMemo } from 'react';
import { usePostV1ProcessExportComplete } from '../../api/generated/endpoint';
import {
    CompleteProcessExportRequest,
    ProcessExportStatusEnum,
} from '../../api/generated/models';

const AvailableExports = ({ dropDownData }: any) => {
    // Check if there are any completed exports (not in progress)
    const hasCompletedExports = useMemo(() => {
        if (!dropDownData || dropDownData.length === 0) return false;
        return dropDownData.some(
            (item: any) => item.status !== ProcessExportStatusEnum.NUMBER_1
        );
    }, [dropDownData]);
    const exportMutation = usePostV1ProcessExportComplete();

    const handleSelect = (
        value: ValueType,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _item: ItemDataType,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _event: SyntheticEvent<Element, Event>
    ) => {
        const postRequest: CompleteProcessExportRequest = {
            transactionId: Number(value),
        };

        exportMutation.mutate(
            { data: postRequest },
            {
                onSuccess: (data: any) => {
                    if (data && data.exportSASUrl) {
                        const downloadLink = document.createElement('a');
                        downloadLink.href = data.exportSASUrl;
                        downloadLink.target = '_blank';
                        downloadLink.download = 'export.xlsx';
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                    }
                },
                onError: (error) => {
                    console.error('Export failed:', error);
                },
            }
        );
    };

    const prefixTemplate = (
        item: ItemDataType
    ): React.ReactNode | undefined => {
        if (item.iconName) {
            return (
                <span
                    className={`Appkit4-icon icon-${item.iconName as string}`}
                />
            );
        }
        return undefined;
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <DropdownButton
                data={dropDownData}
                splitButton={false}
                customTriggerClassName="custom-node"
                align="right"
                onSelect={handleSelect}
                customTriggerNode
                prefixTemplate={prefixTemplate}
            >
                <span className={`Appkit4-icon icon-notification-outline`} />
            </DropdownButton>
            {hasCompletedExports && (
                <span
                    style={{
                        position: 'absolute',
                        top: '0px',
                        right: '0px',
                        width: '8px',
                        height: '8px',
                        backgroundColor: '#e74c3c',
                        borderRadius: '50%',
                        border: '1px solid white',
                        pointerEvents: 'none',
                    }}
                    aria-label="New exports available"
                />
            )}
        </div>
    );
};

export default AvailableExports;
